<template>
  <div class="article-cols" :class="colsClasses">
    <slot />
  </div>
</template>

<script>
export default {
  computed: {
    /**
     * Columns classes
     */
    colsClasses() {
      let classes = ''
      if (this.direction) {
        classes += `${classes.length ? ' ' : ''}article-cols--${this.direction}`
      }
      if (this.horizontalAlign) {
        classes += `${classes.length ? ' ' : ''}article-cols--h-${this.horizontalAlign}`
      }
      if (this.verticalAlign) {
        classes += `${classes.length ? ' ' : ''}article-cols--v-${this.verticalAlign}`
      }
      return classes
    },
  },
  props: {
    /**
     * Column flow direction,
     * values: "" | "reverse"
     * default: ""
     */
    direction: {
      default: '',
      type: String,
    },

    /**
     * Horizontal alignment,
     * values: "center" | "left" | "right"
     * default: "center"
     */
    horizontalAlign: {
      default: 'center',
      type: String,
    },

    /**
     * Vertical alignment,
     * values: "center" | "top" | "bottom"
     * default: "center"
     */
    verticalAlign: {
      default: 'center',
      type: String,
    },
  },
}
</script>

<style lang="postcss" scoped>
@screen desktop {
  .article-cols {
    @apply flex flex-no-wrap items-center;
  }
  .article-cols.article-cols--reverse {
    @apply flex-row-reverse;
  }

  /* Horizontal alignment */
  .article-cols.article-cols--h-center {
    @apply justify-around; /* Fallback value for older browsers */
    justify-content: space-evenly;
  }
  .article-cols.article-cols--h-left {
    @apply justify-start;

    & > .article-col {
      @apply mx-0 pl-0;
    }
  }
  .article-cols.article-cols--h-right {
    @apply justify-end;

    & > .article-col {
      @apply mx-0 pr-0;
    }
  }

  /* Vertical alignment */
  .article-cols.article-cols--v-center {
    @apply items-center;
  }
  .article-cols.article-cols--v-top {
    @apply items-start;
  }
  .article-cols.article-cols--v-bottom {
    @apply items-end;
  }
}
</style>
